import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import API from "../Api/Api";
import { trackConversion } from '../Functions/gtag';
import { trackLinkedInConversion } from "../Functions/linkedin";
const AuthSuccess = () => {
  const navigate = useNavigate();
 const verifyLink = async (token,userId,userType,isSignUp)=>{
  const payload = {
    token:token, userId:userId
  }
  const response = await API.post(`/`+(userType == 2?'business':'loginEmail')+`/verify-login`, payload);
  if(response.token){
    localStorage.setItem("jwt_token_jobcritic", response.token);
    localStorage.setItem("jobcritic_usertype", userType);
    const decoded = jwtDecode(response.token);
    if(isSignUp == 1){
      trackConversion('AW-17044846885/tul8CI7G_L8aEKXyzr8_');
      trackLinkedInConversion(22010089);
      localStorage.setItem("welcome_popup", "1");
      
    }
    //console.log("User Info:", decoded);
    if(userType == 2){
      if(response.is_business_submitted){
        if(localStorage.getItem("redirectPath_jobcritic")){
          window.location.href = localStorage.getItem("redirectPath_jobcritic"); 
        }else{
          window.location.href = "/verifications"; // Page reload ke saath redirect karega
        }
      }else{
        window.location.href = "/business-form";
      }
      
    }else{
      window.location.href = "/profile";
    }
    
  }else if(response.error_type==1){
    window.location.href = "/expire_link?userType="+userType;
  }
  
       
 };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userId = params.get("userId");
    const userType = params.get("userType");
    const isSignUp = params.get("signup");
    
    if(token && userId){
      verifyLink(token,userId,userType,isSignUp);
    }else{
      if (token) {
        localStorage.setItem("jwt_token_jobcritic", token);
        const decoded = jwtDecode(token);
        if(isSignUp == 1){
          trackConversion('AW-17044846885/tul8CI7G_L8aEKXyzr8_');
          trackLinkedInConversion(22010089);
          localStorage.setItem("welcome_popup", "1");
          
        }
        if(localStorage.getItem("redirectPath_jobcritic")){
          window.location.href = localStorage.getItem("redirectPath_jobcritic"); 
        }else{
          window.location.href = "/profile"; // Page reload ke saath redirect karega
        }
       
      }
    }
    
  }, [navigate]);

  return ;
};

export default AuthSuccess;
